import {
    createRouter,
    createWebHistory
} from 'vue-router';
// import Home from '../views/Home.vue';
import Dashboard from '../views/Dashboard.vue';
import Login from '../views/Login.vue';
import Advanture from '../views/Advanture.vue';
import Inventory from '../views/Inventory.vue';
import MapView from '../views/MapView.vue';
import Market from '../views/Market.vue';
import Crafting from '../views/Crafting.vue'
import ApiService from '../services';
import mainView from '../components/Main';
import PathNotFound from '../components/NotFound.vue';
const routes = [{
        path: '/',
        redirect: '/dashboard',
        component: mainView,
        // dashboard auth guard
        beforeEnter(to, from, next) {
            if (!isLogin()) {
                next('/login');
            } else {
                next();
            }
        },
        children: [{
            path: '/dashboard',
            name: 'dashboard',
            props: true,
            component: Dashboard,
            meta: {
                sideBarKey: 'Dashboard'
            },
        }, ],
    },
    {
        path: '/advanture',
        redirect: '/advanture',
        component: mainView,
        // dashboard auth guard
        beforeEnter(to, from, next) {
            if (!isLogin()) {
                next('/login');
            } else {
                next();
            }
        },
        children: [{
            path: '/advanture',
            name: 'advanture',
            props: true,
            component: Advanture,
            meta: {
                sideBarKey: 'Advanture'
            },
        }, ],
    },
    {
        path: '/inventory',
        redirect: '/inventory',
        component: mainView,
        // dashboard auth guard
        beforeEnter(to, from, next) {
            if (!isLogin()) {
                next('/login');
            } else {
                next();
            }
        },
        children: [{
            path: '/inventory',
            name: 'inventory',
            props: true,
            component: Inventory,
            meta: {
                sideBarKey: 'Inventory'
            },
        }, ],
    },
    {
        path: '/crafting',
        redirect: '/crafting',
        component: mainView,
        // dashboard auth guard
        beforeEnter(to, from, next) {
            if (!isLogin()) {
                next('/login');
            } else {
                next();
            }
        },
        children: [{
            path: '/crafting',
            name: 'crafting',
            props: true,
            component: Crafting,
            meta: {
                sideBarKey: 'crafting'
            },
        }, ],
    },
    {
        path: '/map',
        redirect: '/map',
        component: mainView,
        // dashboard auth guard
        beforeEnter(to, from, next) {
            if (!isLogin()) {
                next('/login');
            } else {
                next();
            }
        },
        children: [{
            path: '/map',
            name: 'map',
            props: true,
            component: MapView,
            meta: {
                sideBarKey: 'map'
            },
        }, ],
    },
    {
        path: '/market',
        redirect: '/market',
        component: mainView,
        // dashboard auth guard
        beforeEnter(to, from, next) {
            if (!isLogin()) {
                next('/login');
            } else {
                next();
            }
        },
        children: [{
            path: '/market',
            name: 'market',
            props: true,
            component: Market,
            meta: {
                sideBarKey: 'market'
            },
        }, ],
    },
    {
        path: '/:pathMatch(.*)*',
        component: PathNotFound
    },
    {
        path: '/login',
        name: 'Login',
        // props: false,
        component: Login,
    },
];
const isLogin = function () {
    return ApiService.isLogin();
};
const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

export default router;